import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import styles from './AdminNav.module.scss';
import authService from '../../../services/authService';
import { 
  IoHomeOutline, IoCubeOutline, IoReceiptOutline, IoLogOutOutline, 
  IoAppsOutline, IoEyeOutline, IoClose, IoInformationCircleOutline,
  IoImagesOutline, IoStorefrontOutline, IoBookOutline, IoLeafOutline, 
  IoBarChartOutline, IoMegaphoneOutline, IoDesktopOutline, IoHelpCircleOutline 
} from 'react-icons/io5';

const AdminNav = ({ isSidebarOpen, closeSidebar }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    authService.logout();
    navigate('/admin/login');
  };

  const getNavLinkClass = ({ isActive }) => {
    return isActive ? `${styles.navLink} ${styles.active}` : styles.navLink;
  };

  const handleClickLink = () => {
    closeSidebar();
  };

  return (
    <nav className={`${styles.adminNav} ${isSidebarOpen ? styles.open : ''}`}>
      <div className={styles.logoRow}>
        <div className={styles.logo}>
          <Link to="/admin/dashboard" onClick={handleClickLink}>An Nhiên Admin</Link>
        </div>
        <button className={styles.closeButton} onClick={closeSidebar}>
          <IoClose />
        </button>
      </div>

      <Link to="/" target="_blank" rel="noopener noreferrer" className={styles.viewSiteLink}>
        <IoEyeOutline /> Xem trang web
      </Link>
      
      <div className={styles.menu}>
        <NavLink to="/admin/dashboard" className={getNavLinkClass} onClick={handleClickLink} end>
          <IoHomeOutline /> Tổng quan
        </NavLink>
        <NavLink to="/admin/banners" className={getNavLinkClass} onClick={handleClickLink}>
          <IoDesktopOutline /> Quản lý Banner
        </NavLink>        
        <NavLink to="/admin/orders" className={getNavLinkClass} onClick={handleClickLink}>
          <IoReceiptOutline /> Quản lý Đơn hàng
        </NavLink>        
        <NavLink to="/admin/products" className={getNavLinkClass} onClick={handleClickLink}>
          <IoCubeOutline /> Quản lý Sản phẩm
        </NavLink>       
        <NavLink to="/admin/inventory" className={getNavLinkClass} onClick={handleClickLink}>
          <IoStorefrontOutline /> Quản lý Kho
        </NavLink>
        <NavLink to="/admin/revenue" className={getNavLinkClass} onClick={handleClickLink}>
          <IoBarChartOutline /> Doanh Thu
        </NavLink>
        <NavLink to="/admin/categories" className={getNavLinkClass} onClick={handleClickLink}>
          <IoAppsOutline /> Quản lý Danh mục
        </NavLink>
        <NavLink to="/admin/story" className={getNavLinkClass} onClick={handleClickLink}>
          <IoBookOutline /> Câu Chuyện Trầm
        </NavLink>
        <NavLink to="/admin/raw-material" className={getNavLinkClass} onClick={handleClickLink}>
          <IoLeafOutline /> Vùng Nguyên Liệu
        </NavLink>
        <NavLink to="/admin/about" className={getNavLinkClass} onClick={handleClickLink}>
          <IoInformationCircleOutline /> Giới Thiệu Công Ty
        </NavLink>
        <NavLink to="/admin/faq" className={getNavLinkClass} onClick={handleClickLink}>
          <IoHelpCircleOutline /> Quản lý FAQ
        </NavLink>

        <NavLink to="/admin/coupons" className={getNavLinkClass} onClick={handleClickLink}>
          <IoMegaphoneOutline /> Quản lý khuyến mãi
        </NavLink>
        <NavLink to="/admin/popup" className={getNavLinkClass} onClick={handleClickLink}>
          <IoMegaphoneOutline /> Quản Lý Popup
        </NavLink>
        <NavLink to="/admin/media" className={getNavLinkClass} onClick={handleClickLink}>
          <IoImagesOutline /> Quản lý Ảnh
        </NavLink>

      </div>    
      <button onClick={handleLogout} className={styles.logoutButton}>
        <IoLogOutOutline /> Đăng Xuất
      </button>
    </nav>
  );
};

export default AdminNav;